import type { IconData } from '@stacksjs/iconify-core'

export const swapHorizontal: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m364.118 67.313l69.255 69.255H160v32h273.373l-69.255 69.255l22.627 22.627l107.883-107.882L386.745 44.687zM147.882 267.882l-22.627-22.627L17.373 353.137L125.255 461.02l22.627-22.627l-69.255-69.256H352v-32H78.627z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default swapHorizontal
